import MailItem from './MailItem';

export default MailItem;


// WEBPACK FOOTER //
// /src/components/mailList/mailItem/index.js